import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { glossaryKeys } from '@/shared/lib/query/queryKeys';

import { fetchTaggedAssetsCount } from '@/features/glossary/api';

export const useTaggedAssetsCount = (termFqn: string) => {
  return useQueryWithBoundary<number>({
    queryKey: glossaryKeys.taggedAssetsCount(termFqn),
    queryFn: () => fetchTaggedAssetsCount(termFqn),
    enabled: !!termFqn,
    staleTime: 5 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
